if (!customElements.get('fc-slider')) {
class FcSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-fc-track]');
    this.prevBtn = this.querySelector('[data-fc-prev]');
    this.nextBtn = this.querySelector('[data-fc-next]');
    this.progress = this.querySelector('[data-fc-progress]');
    this.nav = this.querySelector('[data-fc-nav]');

    if (!this.track) return;

    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.prevBtn?.addEventListener('click', () => this.scroll(-1));
    this.nextBtn?.addEventListener('click', () => this.scroll(1));

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.track);

    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  scroll(direction) {
    const slide = this.track.querySelector('.fc-slider__slide');
    if (!slide) return;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const distance = (slide.offsetWidth + gap) * direction;
    this.track.scrollBy({ left: distance, behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const maxScroll = scrollWidth - clientWidth;
    const canScroll = maxScroll > 1;

    // Show/hide entire nav
    if (this.nav) this.nav.hidden = !canScroll;

    // Button states
    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 1;

    // Progress bar
    if (this.progress && canScroll) {
      const pct = scrollLeft / maxScroll;
      const scale = 0.35 + (pct * 0.65);
      this.progress.style.transform = `scaleX(${scale})`;
    }
  }
}

customElements.define('fc-slider', FcSlider);
}
